import CONSTANTS from "./Constants";

export default class Components {

    constructor (scene) {
        this.scene = scene
        this.components = new Map()
    }

    init (elements) {
        const components = elements.get()
        if( components.length === 0 ){
            return
        }
        components.forEach((component) => {
            const uuid = component.getAttribute('id')
            this.components.set(uuid, {
                element: component,
                status: 0,
                visible: !this.scene.isElementHidden(component),
                inViewport: false
            })
        })

        // bind Element actions on all elements
        this.elements = elements;
        this.actionHandler = (e, data) => this.onAction(e, data);
        elements.on(CONSTANTS.EVENT_ELEMENT_ACTION, this.actionHandler);

        this.componentEventHandler = this.onEvent.bind(this);
        this.scene.getSceneElement(false).addEventListener('maglr-webcomponent', this.componentEventHandler);

        const options = {
            // trackVisibility: true,
            // delay: 100,
        }
        this.intersectionObserver = new IntersectionObserver( (entries) => {
            if (this.destroyed) return;
            // loop entries array, during scroll its only 1 entry but on pageLoad there can be multiple entries
            entries.forEach((entry) => {
                const component = this.components.get(entry.target.getAttribute('id'))
                component.inViewport = entry.isIntersecting

                // this.onStatusUpdate(component)
                this.componentIntersecting(component)
            })
        }, options);
    }

    onEvent (e) {
        const component = this.components.get(e.detail.uuid)
        switch (e.detail.type) {
            case 'status':
                const oldStatus = component.status
                component.status = e.detail.status.code
                if (oldStatus === 0) {
                    this.componentIntersecting(component)
                }
                break
        }
    }

    onAction (e, data) {
        const component = this.components.get(e.currentTarget.id)
        this.getWebComponentElement(component).doAction(data.action)
    }

    start () {
        this.components.forEach((component) => {
            if (!component.observed) {
                this.intersectionObserver.observe(component.element);
                component.observed = true
            }
        })
    }

    stop () {
        this.components.forEach((component) => {
            this.intersectionObserver.unobserve(component.element);
            component.observed = false
        })
        this.stopComponents()
    }

    destroy () {
        if (this.destroyed) return;
        this.destroyed = true;
        if (this.intersectionObserver) this.intersectionObserver.disconnect();
        if (this.componentEventHandler) {
            this.scene.getSceneElement(false).removeEventListener('maglr-webcomponent', this.componentEventHandler);
            this.elements.off(CONSTANTS.EVENT_ELEMENT_ACTION, this.actionHandler);
        }
        this.components.forEach(component => {
            const element = this.getWebComponentElement(component);
            // An unhydrated custom element has no player methods yet.
            if (typeof element.stop === 'function') element.stop();
        });
        this.components.clear();
    }

    componentIntersecting (component) {
        if (component.status === 0 && this.getWebComponentElement(component).classList.contains('hydrated')) {
            component.status = CONSTANTS.STATUS.READY
        }
        if (component.status > 0 && this.scene.status >= CONSTANTS.STATUS.SHOWN) {
            if (this.scene.spread.screenshotmode || this.scene.spread.pdfmode) {
                this.getWebComponentElement(component).goToScreenshotState()
            } else if (component.visible && component.inViewport) {
                this.getWebComponentElement(component).start()
            } else {
                this.getWebComponentElement(component).pause()
            }
        }
    }

    stopComponent (element) {
        const component = this.components.get(element.id)
        this.getWebComponentElement(component).stop()
        component.visible = false
    }

    stopComponents () {
        this.components.forEach(component => {
            this.getWebComponentElement(component).stop()
        })
    }

    visibilityUpdated (element) {
        const component = this.components.get(element.id)
        const oldValue = component.visible
        component.visible = !element.closest('.hidden')

        if (oldValue !== component.visible) {
            this.componentIntersecting(component)
        }
    }

    getWebComponentElement (component) {
        return component.element.children[0]
    }
}
